// Copyright (c) 2016 Deere & Company

import DbsSettings from '../../user/dbs-settings/state-connector';

export default {
    component: DbsSettings,
    name: 'DBS',
    path: 'dbs'
};



// WEBPACK FOOTER //
// ./src/routes/settings/dbs.js